export default {
    title: 'Integrate Active carriers search into your business processes',
    text: 'Use API to set up data exchange between ATI.SU and your service or accounting system. This is an easy way to search for interested contractors and potential partners in familiar software. ',
    getAccess: 'Get access',
    details: 'Read more',
    accessLicense: 'Access to the API is paid, you can pay for it as for any other license.'
};